module.exports = __webpack_public_path__ + "img/appAsset-setup--FirstStep.d447d8b5.svg";